import React from 'react';
import Reveal from 'react-reveal';

const DesignBanner = () => {
    return(
        <section className="seo_home_area">
            <div className="banner_top">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center seo_banner_content">
                            <Reveal effect="fadeInUp" duration={500}><h2>Data Analytics <br/>for the Cold Chain</h2></Reveal>
                        </div>
                    </div>
                    <div className="row saas_home_img">
                        <Reveal effect="fadeInUp" duration={1400}><img src={require('../../img/seo/hemdahl-screenshot01.png')} alt=""/></Reveal>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default DesignBanner;
